<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ invalid, dirty }"
  >
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <form v-else>
      <div>
        <VTextarea
          v-model="en"
          :disabled="!hasPermission('members.signature.edit')"
          :label="$t('forms.labels.signature_en')"
          :rules="{ max: 400 }"
          data-cy="signatureForm-french"
        />
        <VTextarea
          v-model="fr"
          :disabled="!hasPermission('members.signature.edit')"
          :label="$t('forms.labels.signature_fr')"
          :rules="{ max: 400 }"
          data-cy="signatureForm-english"
        />
        <VFile
          v-model="newFile"
          :disabled="!hasPermission('members.signature.edit')"
          :label="$t('forms.labels.signatureImage')"
          :rules="{
            mimes: acceptedFormats,
            size: 10000000
          }"
        />
        <div v-if="file">
          {{ $t('forms.labels.signatureCurrentImage') }}
          <img
            class="imagePreview"
            :src="previewUrl"
          >
        </div>
      </div>
      <v-row
        align="center"
        justify="end"
        class="mr-1"
      >
        <v-btn
          v-if="file"
          text
          @click.prevent="onClickRemove"
        >
          {{ $t('forms.btn.delete') }}
        </v-btn>
        <v-btn
          color="secondary"
          :disabled="(!dirty && !isFileDirty) || invalid"
          @click.prevent="onClickUpdate"
        >
          {{ $t('forms.btn.save') }}
        </v-btn>
      </v-row>
    </form>
  </ValidationObserver>
</template>

<script>
import { isPlainObject } from 'lodash';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VFile from '@/components/shared/widgets/forms/VuetifyInputs/VFile';

export default {
    components: {
        ValidationObserver,
        VTextarea,
        VFile,
    },
    data() {
        return {
            loading: false,
            file: null,
            newFile: null,
            en: null,
            fr: null,
            isFileDirty: false,
            acceptedFormats: [
                'image/jpeg',
                'image/gif',
                'image/png',
            ],
            size: 10000000,
            previewUrl: null,
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
    },
    async created() {
        await this.getMemberInfo();
    },
    methods: {
        async getMemberInfo() {
            this.loading = true;
            const { data } = await this.$rq.getMemberInfo('me');

            this.file = data.signature.file;
            this.en = data.signature.en || '';
            this.fr = data.signature.fr || '';

            if (isPlainObject(this.file)) {
                this.previewUrl = await this.$rq.getFileUrl(this.file.id);
            }

            this.loading = false;
        },
        onClickRemove() {
            this.$root.$emit('showModal', {
                title: this.$t('profile.signature.deleteCurrentFile'),
                payload: {
                    msg: this.$t('profile.signature.deleteCurrentFileMessage'),
                },
                component: Vue.component('ConfirmForm', ConfirmForm),
                onConfirm: () => { this.removeSignature(); },
                isForm: false,
            });
        },
        async removeSignature() {
            await this.$rq.deleteSignatureFile('me');
            this.newFile = null;
            await this.getMemberInfo();
        },
        async onClickUpdate() {
            await this.$rq.updateSignature('me', {
                en: this.en,
                fr: this.fr,
            });

            if (this.newFile) {
                const formData = new FormData();
                formData.append('file', this.newFile);
                await this.$rq.addSignatureFile('me', formData);
            }

            this.$toasted.global.toast_success({
                message: this.$t('profile.signature.updated'),
            });
            this.newFile = null;
            await this.getMemberInfo();
        },
    },
};
</script>

<style lang="scss" scoped>
  .imagePreview {
    display: block;
    margin-top: 20px;
    max-width: 350px;
  }
</style>
